import "./OutputParagraph.css";

const OutputParagraph = ({ className, text }) => {
  return <p className={className}>{text}</p>;
};
export default OutputParagraph;
